<template>
  <div class="animate__animated animate__fadeIn heightbody">
    <div class="row mt-3">
        <div class="col-md-3">
            <label class="form-label">Folio de Carta</label>
            <input type="email" class="form-control" v-model="folioCarta" disabled>
        </div>
        <div class="col-md-6">
            <label class="form-label">Hospital</label>
            <input type="email" class="form-control" v-model="hospital" disabled>
        </div>
        <div class="col-md-3">
            <label class="form-label">Póliza</label>
            <input type="email" class="form-control" v-model="poliza" disabled>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-4">
            <label class="form-label">Ramo</label>
            <input type="email" class="form-control" v-model="ramo" disabled>
        </div>
        <div class="col-md-4">
            <label class="form-label">Producto</label>
            <input type="email" class="form-control" v-model="producto" disabled>
        </div>
        <div class="col-md-4">
            <label class="form-label">Movimiento</label>
            <input type="email" class="form-control" v-model="movimiento" disabled>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-4">
            <label class="form-label">Nombre(s) del asegurado</label>
            <input type="email" class="form-control" v-model="nombres" disabled>
        </div>
        <div class="col-md-4">
            <label class="form-label">Apellido Paterno</label>
            <input type="email" class="form-control" v-model="paterno" disabled>
        </div>
        <div class="col-md-4">
            <label class="form-label">Apellido Materno</label>
            <input type="email" class="form-control" v-model="materno" disabled>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-5">
            <label class="form-label">Clave Agente - Nombre</label>
            <input type="email" class="form-control" v-model="claveAgente" disabled>
        </div>
    </div>

    <div class="row text-center mt-5">
        <div class="col-md-12">
            <h6>Si los datos son correctos preciona continuar</h6>
        </div>
        <div class="col-md-12">
            <button class="btn btn-primary mt-3 col-3" type="submit" style="border-radius: 15px;" @click="getRequisitos"><i class="fas fa-check-circle mr-2"></i>Continuar</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        getRequisitos: Function,
        folioCarta: String,
        hospital: String,
        poliza: String,
        ramo: String,
        producto: String,
        movimiento: String,
        nombres: String,
        paterno: String,
        materno: String,
        claveAgente: String,
    },
    data(){
        return {
            
        }
    }
}
</script>

<style scoped>
.btn-primary{
    background-color: #1e536b !important;
    border-color: #1e536b !important;
}
</style>